export default __webpack_public_path__ + "static/smellsLikeLemonade-2dabca8a86d8b0b5d230dce186e2dd08.png";